<!-- Modal -->
<div class="modal fade" id="inactivityModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="exampleModalLabel">Utloggad</h5>
      </div>
      <div class="modal-body">
        På grund av inaktivitet har du blivit utloggad.
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" data-dismiss="modal" (click)="login()">Logga in</button>
      </div>
    </div>
  </div>
</div>
